export const ClosedScreen = ({revealed}: {revealed: boolean}) => (
    <main className="ph-page">
        <div className="ph-stack ph-center ph-fill">
            <h1 className="ph-title">Voting has closed</h1>
            <p className="ph-muted">
                {revealed
                    ? 'This vote has finished.'
                    : 'You were just too late. Watch the big screen!'}
            </p>
        </div>
    </main>
);
